const MSWORD = 'application/msword',
  OPENXML = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  PDF = 'application/pdf',
  RTF = 'text/rtf',
  UNKNOWN = '',
  ALL = [MSWORD, OPENXML, PDF, RTF];

function parseTypeMime(typeMime) {
  if (typeof typeMime !== 'string') {
    return UNKNOWN;
  }

  const m = typeMime.toLowerCase();

  return ALL.includes(m) ? m : UNKNOWN;
}

function isTypeValide(mimeType, mimeTypesAutorises) {
  const type = parseTypeMime(mimeType);
  return mimeTypesAutorises.includes(type);
}

export default {
  MSWORD: MSWORD,
  OPENXML: OPENXML,
  PDF: PDF,
  RTF: RTF,
  UNKNOWN: UNKNOWN,
  ALL: ALL,
  parseTypeMime: parseTypeMime,
  isTypeValide: isTypeValide
};
